import * as React from 'react';
import { WithChildrenCommonProps } from '@types';
import { getFormFieldLabelStylesAsClassName } from './field-label-styles';
import { Typography } from '@components/typography';
import { twMerge } from 'tailwind-merge';

export interface IFieldLabelProps extends React.LabelHTMLAttributes<HTMLLabelElement> {
  /** When we have the focus on the input*/
  hasFocusedValue?: boolean;
  /** Flag to indicate whether the field is disabled */
  isDisabled?: boolean;
  /** Flag to indicate whether the label should be left aligned */
  leftAligned?: boolean;
}

export type FieldLabelProps = WithChildrenCommonProps<
  Omit<IFieldLabelProps, 'css'>
>;

export const FieldLabel = React.forwardRef(
  (
    props: FieldLabelProps,
    ref: React.ForwardedRef<HTMLLabelElement>
  ): JSX.Element => {
    const {
      hasFocusedValue = false,
      children,
      isDisabled = false,
      leftAligned = false,
      className: classNameProp,
      ...rest
    } = props;
    const twClassName = twMerge(
      getFormFieldLabelStylesAsClassName(
        hasFocusedValue,
        isDisabled,
        props.leftAligned || false
      ),
      classNameProp
    );

    return (
      <Typography
        component="label"
        variant="body2"
        bold
        className={twClassName}
        ref={ref}
        {...rest}
      >
        {children}
      </Typography>
    );
  }
);

FieldLabel.displayName = 'FieldLabel';
